import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.5rem',
}));

export const EditIcon = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  color: '#6250ED',
  cursor: 'pointer',
  userSelect: 'none',

  svg: {
    fontSize: '1rem',
  },

  span: {
    fontSize: '0.875rem',
    margin: 0,
  },
}));

export const TopicsSearchWrapper = styled('div')(() => ({
  padding: '0.75rem',
  background: '#F9FAFB',
  borderRadius: '0.25rem',
}));

export const Pills = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '0.5rem',
}));

export const Pill = styled('div')(() => ({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.25rem',
  padding: '0.25rem 0.5rem',
  background: '#F9FAFB',
  border: '1px solid #E4E7EC',
  borderRadius: '0.75rem',
  userSelect: 'none',

  span: {
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#101828',
    margin: 0,
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },

  svg: {
    color: '#101828',
    fontSize: '1rem',
  },
}));
